export default __webpack_public_path__ + "static/media/pattern_apple.d6f3d387.png";